import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Card } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { LogIn } from 'lucide-react';

export default function TrainerLoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { trainerLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) { setError('Please enter username and password'); return; }
    setLoading(true);
    setError('');
    try {
      await trainerLogin(username.trim(), password);
      navigate('/trainer/dashboard');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed. Please check your credentials.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="trainer-login-page">
      <Card className="w-full max-w-sm p-8 border shadow-sm">
        <div className="text-center mb-8">
          <img
            src="/tb-logo.png"
            alt="Logo"
            className="h-16 mx-auto mb-4 object-contain"
            data-testid="trainer-login-logo"
          />
          <h1 className="text-xl font-bold text-slate-900 tracking-tight">Trainer Batch Management</h1>
          <p className="text-xs text-slate-400 mt-1">Sign in to access your batches and reports</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="p-2.5 bg-red-50 border border-red-200 rounded-sm text-xs text-red-600" data-testid="trainer-login-error">
              {error}
            </div>
          )}
          <div>
            <Label className="text-xs font-medium text-slate-600">Username</Label>
            <Input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter your username"
              className="h-10 text-sm mt-1"
              autoFocus
              data-testid="trainer-username-input"
            />
          </div>
          <div>
            <Label className="text-xs font-medium text-slate-600">Password</Label>
            <Input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="h-10 text-sm mt-1"
              data-testid="trainer-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-10 bg-violet-600 hover:bg-violet-700 text-sm font-medium"
            data-testid="trainer-login-submit"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
            ) : (
              <><LogIn className="w-4 h-4 mr-2" />Sign In</>
            )}
          </Button>
        </form>

        <p className="text-[10px] text-slate-300 text-center mt-6">
          Contact your admin if you need login credentials
        </p>
      </Card>
    </div>
  );
}
